import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './firebase';
// eslint-disable-next-line no-duplicate-imports
import { sendWebVitals } from './firebase';
import { registerServiceWorker } from './shared/utils/serviceWorker';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for offline capabilities
registerServiceWorker({
  onSuccess: (_registration) => {
    console.log('Service Worker registered successfully');
  },
  onUpdate: (_registration) => {
    console.log('Service Worker update available');
    // You could show a notification to the user here
    if (window.confirm('A new version is available. Reload to update?')) {
      window.location.reload();
    }
  },
  onError: (_error) => {
    console.error('Service Worker registration failed');
  },
});

// Performance monitoring setup - see https://bit.ly/CRA-vitals
reportWebVitals(sendWebVitals);
